import React, { useState } from 'react'
import PropTypes from 'prop-types'
import isEmpty from 'lodash/isEmpty'
import c from 'classnames'
import Select from 'react-select'

export function ItemModel({
  className,
  itemId,
  options,
  onChange,
  disabled,
  current,
  ...props
}) {
  const [itenModelValue, setItemModelValue] = useState(current.label)
  const [currentOption, setCurrentOption] = useState(
    isEmpty(current.value) ? null : current
  )
  const onChangeInput = (e) => {
    setItemModelValue(e.target.value)
    onChange({ value: null, label: itenModelValue })
  }

  const onChangeSelector = ({ label, value }) => {
    setCurrentOption({ label, value })
    onChange({ label, value })
  }
  return (
    <div className={c('item-model-input', className)} {...props}>
      {options.length <= 0 ? (
        <input
          disabled={disabled}
          type="text"
          className="form-control"
          value={itenModelValue}
          onChange={onChangeInput}
        />
      ) : (
        <Select
          isDisabled={disabled}
          className="multiselect"
          placeholder="Select Item Model"
          options={options.map((o) => ({ value: o.id, label: o.name }))}
          isSearchable={false}
          classNamePrefix="multiselect"
          onChange={onChangeSelector}
          value={currentOption}
        />
      )}
    </div>
  )
}
export default ItemModel

ItemModel.propTypes = {
  className: PropTypes.string,
  itemId: PropTypes.number,
  current: PropTypes.object,
  options: PropTypes.array,
  onChange: PropTypes.func,
  disabled: PropTypes.bool,
}

ItemModel.defaultProps = {
  className: '',
  itemId: Date.now(),
  current: {},
  options: [],
  onChange: () => {},
  disabled: false,
}
